import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Card from 'WeployDesignLanguage/Card';

const StyledCard = styled(Card)`
  padding: ${props => props.theme.spacing[3]};
`;

const MetricContainer = styled.div`
  display: inline-flex;
  width: 100%;
`;

const MetricItem = styled.div`
  display: flex;
  width: 33.3%;
  flex-direction: column;
  align-items: center;

  &:hover {
    cursor: pointer;
  }
`;

const MetricNumber = styled.h4`
  font-size: 3rem;
`;

const MetricCaption = styled.span`
  ${props => props.theme.typography.caption}
`;

const StyledTitle = styled.h6`
  margin-bottom: ${props => props.theme.spacing[2]};
`;

const DashboardMetrics = ({
  timesheetsToApprove,
  totalJobs,
  totalWeployees,
  onJobsMetricClick,
  onWeployeesMetricClick,
  onTimesheetsMetricClick,
}) => (
  <StyledCard>
    <StyledTitle>Overview</StyledTitle>
    <MetricContainer>
      <MetricItem onClick={onJobsMetricClick}>
        <MetricNumber>
          { totalJobs }
        </MetricNumber>
        <MetricCaption>
          Jobs
        </MetricCaption>
      </MetricItem>
      <MetricItem onClick={onWeployeesMetricClick}>
        <MetricNumber>
          { totalWeployees }
        </MetricNumber>
        <MetricCaption>
          Weployees
        </MetricCaption>
      </MetricItem>
      <MetricItem onClick={onTimesheetsMetricClick}>
        <MetricNumber>
          { timesheetsToApprove }
        </MetricNumber>
        <MetricCaption>
          Timesheets<br /> To Approve
        </MetricCaption>
      </MetricItem>
    </MetricContainer>
  </StyledCard>
);

DashboardMetrics.propTypes = {
  timesheetsToApprove: PropTypes.number.isRequired,
  totalJobs: PropTypes.number.isRequired,
  totalWeployees: PropTypes.number.isRequired,
  onJobsMetricClick: PropTypes.func,
  onWeployeesMetricClick: PropTypes.func,
  onTimesheetsMetricClick: PropTypes.func,
};

DashboardMetrics.defaultProps = {
  onJobsMetricClick: () => {},
  onWeployeesMetricClick: () => {},
  onTimesheetsMetricClick: () => {},
};

export default DashboardMetrics;
